import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { NotificationService } from '../notification/notification.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EditGlobalTranslationModalComponent } from '../edit-global-translation-modal/edit-global-translation-modal.component';
import { GlobalTranslationApiService } from 'src/app/api/global-translations-api.service';
import { LocalisationLanguageService } from 'src/app/services/localisation-language.service';

@Component({
  selector: 'app-button-global-translation',
  templateUrl: './button-global-translation.component.html',
  styleUrls: ['./button-global-translation.component.scss']
})
export class ButtonGlobalTranslationComponent implements OnInit {

  @Input() entityType!: string;
  @Input() entityId!: string;
  @Input() refValue!: string;
  @Input() multiline: boolean = false;
  @Input() translations!: any[];


  constructor(
    private globalTranslationsApiService: GlobalTranslationApiService,
    private localisationLanguageService: LocalisationLanguageService,
    private loaderService: LoaderService,
    private notificationService: NotificationService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.initTranslations();
  }

  async initTranslations() {
    let languages = this.localisationLanguageService.getUsedLanguages();
    languages = languages.filter((lang:any)=>lang.code != 'fr-FR');
    
    if(!this.translations){
      let translations = await this.globalTranslationsApiService.getTranslaletionsByTypeAndId(this.entityType, this.entityId);
      this.translations = [];
      for (const lang of languages) {
        let existingTranslation = (translations || []).find((t:any) => t.codeLang == lang.code);
        if (existingTranslation) {
          existingTranslation.flag = lang.flag;
          this.translations.push(existingTranslation);
        } else {
          this.translations.push({
            entityType: this.entityType,
            entityId: this.entityId,
            codeLang: lang.code,
            flag: lang.flag,
            value: null
          });
        }
      }
    }else{
      for (const lang of languages) {
        let existingTranslation = (this.translations || []).find(t => t.codeLang == lang.code);
        if (existingTranslation) {
          existingTranslation.flag = lang.flag;
        } else {
          this.translations.push({
            entityType: this.entityType,
            entityId: this.entityId,
            codeLang: lang.code,
            flag: lang.flag,
            value: null
          });
        }
      }
    }
    
  }

  updateTranslations(event:any) {

    event.stopPropagation();
    event.preventDefault();
    

    const options: NgbModalOptions = {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modal-top'
    };

    const translationsCpy:any[] = [];
    this.translations.forEach(val => translationsCpy.push(Object.assign({}, val)));

    let translationsModal = this.modalService.open(EditGlobalTranslationModalComponent, options);
    translationsModal.componentInstance.entityType = this.entityType;
    translationsModal.componentInstance.refValue = this.refValue;
    translationsModal.componentInstance.multiline = this.multiline;
    translationsModal.componentInstance.translations = translationsCpy;

    translationsModal.result
      .then((translations) => {
        if (translations) {
          this.saveTranslation(translations);
        } else {
          console.log(this.translations);

        }

      })
      .catch(() => {
        console.log(this.translations);
      });
  }

  async saveTranslation(translations:any[]) {
    this.loaderService.showLoader();
    try {
      this.translations = await this.globalTranslationsApiService.updateTranslaletionsByTypeAndId(this.entityType, this.entityId, translations);
      await this.initTranslations();
      this.notificationService.success('success.update');
    } catch (error:any) {
      console.log(error);
      this.notificationService.error();
    } finally {
      this.loaderService.hideLoader();
    }
  }

}
